import { Col, Form, Input, Label, Row } from 'reactstrap';
import SelectOne from './SelectOne';
import SelectTwo from './SelectTwo';
import CreateNewCategory from './CreateNewCategory';
import SelectFour from './SelectFour';
import SelectFive from './SelectFive';
import {
    ChooseYourCurrency,
    InitialCost,
    ProductStocks,
    SellingPrice
} from '../../../../../../utils/Constant';
import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { productCategoriesApi } from '../../../../../../Api';
import { numberToVND, parseCurrency } from '../../../../../../utils/helper/functions';

const ProductThree = ({
    categories,
    category_id,
    setProductDetail,
    orginalPrice,
    price,
    productInStock,
    colors
}: {
    categories: any[];
    category_id?: number;
    setProductDetail: any;
    orginalPrice?: number;
    price?: number;
    productInStock?: number;
    colors?: any;
}) => {
    return (
        <div className="sidebar-body">
            <Form>
                <Row className="g-lg-4 g-3">
                    <Col xs="12">
                        <Row className="g-3">
                            <Input
                                type="select"
                                name="category"
                                value={category_id}
                                onChange={(e) =>
                                    setProductDetail({ category_id: Number(e.target.value) })
                                }>
                                {categories.map((item, index) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </Input>
                        </Row>
                    </Col>
                    <Col xs="12">
                        <Row className="g-3 custom-input">
                            <Col sm="6">
                                <Label>
                                    {InitialCost}
                                    <span className="txt-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="initialCost"
                                    value={numberToVND(Number(orginalPrice))}
                                    onChange={(e) =>
                                        setProductDetail({
                                            original_price: parseCurrency(e.target.value)
                                        })
                                    }
                                    // onChange={(e) =>
                                    //     dispatch(
                                    //         setFormValue({
                                    //             name: 'initialCost',
                                    //             value: e.target.value
                                    //         })
                                    //     )
                                    // }
                                />
                            </Col>
                            <Col sm="6">
                                <Label>
                                    {SellingPrice}
                                    <span className="txt-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="initialPrice"
                                    value={numberToVND(Number(price))}
                                    onChange={(e) =>
                                        setProductDetail({ price: parseCurrency(e.target.value) })
                                    }
                                    // onChange={(e) =>
                                    //     dispatch(
                                    //         setFormValue({
                                    //             name: 'initialPrice',
                                    //             value: e.target.value
                                    //         })
                                    //     )
                                    // }
                                />
                            </Col>
                            <Col sm="6">
                                <Label>{'Color'}</Label>
                                <Select
                                    mode="tags"
                                    size="large"
                                    style={{ width: '100%' }}
                                    value={colors}
                                    onChange={(e) => setProductDetail({ colors: e })}
                                    options={[
                                        { value: 'Red', label: 'Red' },
                                        { value: 'Cyan', label: 'Cyan' },
                                        { value: 'Green', label: 'Green' },
                                        { value: 'Yellow', label: 'Yellow' },
                                        { value: 'Blue', label: 'Blue' },
                                        { value: 'Pink', label: 'Pink' }
                                    ]}
                                />
                            </Col>
                            <Col sm="6">
                                <Label>
                                    {ProductStocks}
                                    <span className="txt-danger">*</span>
                                </Label>
                                <Input
                                    type="number"
                                    name="productStocks"
                                    value={productInStock}
                                    onChange={(e) =>
                                        setProductDetail({
                                            product_in_stock: Number(e.target.value)
                                        })
                                    }
                                    // onChange={(e) =>
                                    //     dispatch(
                                    //         setFormValue({
                                    //             name: 'productStocks',
                                    //             value: e.target.value
                                    //         })
                                    //     )
                                    // }
                                />
                            </Col>
                            {/* <TypesOfProduct /> */}
                        </Row>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default ProductThree;
